<template>
  <div class="flex min-h-0 flex-col">
    <div class="min-h-0 flex-grow overflow-hidden">
      <o-scroll>
        <div v-if="pager && pager.items.length">
          <slot :items="pager.items">
            <div v-if="view === 'grid'" class="flex items-start flex-wrap gap-3 mb-8">
              <grid
                v-for="(upload, index) in pager.items"
                :key="upload.idPhoto"
                :upload="upload"
                @click="handlePreview(index)"
                @delete="handleDelete(upload)"
              />
            </div>

            <div v-if="view === 'list'" class="overflow-hidden h-full mb-4">
              <table class="w-full table-auto">
                <tbody>
                  <list
                    v-for="(upload, index) in pager.items"
                    :key="upload.idPhoto"
                    :upload="upload"
                    class="pb-2"
                    @preview="handlePreview(index)"
                    @delete="handleDelete(upload)"
                  />
                </tbody>
              </table>
            </div>
          </slot>
        </div>

        <div v-else-if="$slots.empty && pager.items.length === 0 && !pager.loading" class="">
          <slot name="empty" />
        </div>
      </o-scroll>
    </div>

    <div>
      <o-pagination v-if="pager && pager.items.length" :pager="pager" container-class="py-3 border-t flex justify-between items-center flex-shrink-0 px-4" />
    </div>

    <div v-if="pager && pager.loading" class="h-full w-full inset-0 absolute bg-white/30 backdrop-blur flex items-center justify-center">
      <o-loader />
    </div>

    <preview
      ref="preview"
      :data="pager.items"
      @delete="(upload) => handleDelete(upload)"
    />

    <delete-dialog
      ref="deleteDialog"
      @success="handleDeleteSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

import DeleteDialog from '../actions/Delete.vue'
import Grid from './Grid.vue'
import List from './List.vue'
import Preview from './Preview.vue'

import OPagination from '@/components/elements/Pagination.vue'

interface Props {
  pager: Record<string, any>
  view?: string
}

const props = withDefaults(defineProps<Props>(), {
  view: 'combo',
})

const preview = ref<any>()
const deleteDialog = ref<any>()

onMounted(() => {
  props.pager.load()
})

function handlePreview (index: number) {
  preview.value.open(index)
}

function handleDelete (upload: any) {
  deleteDialog.value.open(upload)
}

function handleDeleteSuccess () {
  props.pager.reload()
  preview.value.index = null
}
</script>
